export function shouldEnableWorkerHealthCheck(params: {
  platform?: string;
  isTauri: boolean;
}) {
  const { platform, isTauri } = params;

  if (platform === 'iOS') {
    return true;
  }

  if (platform === 'macOS' && isTauri) {
    return true;
  }

  return !isTauri;
}
